<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar :dateRangeMenu="false" @on-selected="onPanelSelect">
            <template slot="appliancesMenu">
              <appliances-menu @on-selected="applianceSelect"></appliances-menu>
            </template>
          </graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <highcharts class="charts" :options="chartOptions" ref="areaChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import appliancesMenu from "./components/AppliancesGroupMenu";
import graphToolBar from "@/components/GraphToolBar";
import snackBar from "@/components/SnackBar";

import areaChartOptions from "@/config/charts/area";
import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import { getAppliancesList } from "./components/functions.js";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar,
    appliancesMenu
  },
  data() {
    return {
      chartOptions: null,
      toolBarData: null,
      appliancesData: null
    };
  },

  created() {
    const phaseLang = this.$lang.charts.phase;
    const reactivePowerLang = this.$lang.charts.reactive_power;

    this.chartOptions = {
      chart: {
        polar: false,
        zoomType: "xy"
      },
      boost: {
        enabled: false
      },
      title: {
        text: ""
      },
      subtitle: {
        text: ""
      },
      xAxis: {
        title: {
          text: this.$lang.charts.sample
        }
      },
      yAxis: {
        title: {
          text: this.$lang.charts.active_power
        },
        type: "linear",
        labels: {
          format: "{value} W"
        }
      },
      series: [],
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            menuItems: [
              "viewFullscreen",
              "printChart",
              "separator",
              "downloadCSV",
              "downloadXLS",
              "downloadPNG",
              "downloadPDF",
              "viewData"
            ]
          }
        }
      },
      credits: {
        enabled: false
      },
      colors: [
        "#00bcd4",
        "#f44336",
        "#4caf50",
        "#ff9800",
        "#fb4579",
        "#9761c8",
        "#4b63ec",
        "#fb636a",
        "#206692",
        "#668891"
      ],
      legend: {
        verticalAlign: "top"
      },
      lang: {
        decimalPoint: "."
      },
      navigator: {
        enabled: false
      },
      pane: {
        background: []
      },
      rangeSelector: {
        enabled: false
      },
      responsive: {
        rules: []
      },
      noData: {
        useHTML: true
      },
      plotOptions: {},
      chartarea: {},
      plotarea: {},
      tooltip: {}
    };

    this.chartOptions.tooltip.formatter = function() {
      return (
        this.series.name +
        "<br>" +
        "<b>" +
        this.point.y +
        " W" +
        "</b><br>" +
        "<b>" +
        phaseLang + " " +
        "</b>" +
        this.series.userOptions.phase +
        "<br>" +
        "<b>" +
        reactivePowerLang + " " +
        "</b>" +
        this.series.userOptions.power_Q + 
        " VAr"
      );
    };

    this.chartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };
  },

  methods: {
    applianceSelect(data) {
      this.appliancesData = data;
      if (this.toolBarData) {
        this.getAPIData(this.toolBarData, this.appliancesData);
      }
    },

    onPanelSelect(data) {
      this.toolBarData = data;
      if (this.appliancesData) {
        this.getAPIData(this.toolBarData, this.appliancesData);
      }
    },

    getAPIData(selected, appliancesGroup) {
      const { chart } = this.$refs.areaChart;
      chart.showLoading();

      while (chart.series.length > 0) {
        chart.series[0].remove(false, false);
      }

      this.chartOptions.series = [];
      const applianceFiltered = getAppliancesList(appliancesGroup);

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/nilm/appliances-imprints",
        data: {
          token: getSelectedDeviceToken(selected.device.mac)
        },
        withCredentials: true
      })
        .then(response => {
          response.data.data.forEach(element => {
            const applianceIndex = applianceFiltered.findIndex(
              resp => resp.ID === element.ID
            );

            if (applianceIndex !== -1) {
              this.chartOptions.series.push({
                name: element.name,
                type: "line",
                visible: true,
                data: element.rising_edge.map(x => x / 1000),
                phase: element.phase,
                power_Q: element.reactive_power
              });
            }
          });

          chart.xAxis[0].setExtremes(null, null, true);
        })
        .catch(error => {
          if (error.response.data.code == 610) {
            this.$refs.snackbar.notify(this.$lang.messages.data_not_found);
          } else {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>